/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/discounts/discountcode
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCollectionKey,
  ShopifyCollectionToCustomerBuysCollectionKey,
  ShopifyCollectionToCustomerGetsCollectionKey,
  ShopifyDiscountCustomerBuysCollectionKey,
  ShopifyDiscountCustomerBuysCollectionToCollectionKey,
  ShopifyDiscountCustomerBuysCollectionToDiscountKey,
  ShopifyDiscountCustomerBuysProductKey,
  ShopifyDiscountCustomerBuysProductToDiscountKey,
  ShopifyDiscountCustomerBuysProductToProductKey,
  ShopifyDiscountCustomerBuysProductVariantKey,
  ShopifyDiscountCustomerBuysProductVariantToDiscountKey,
  ShopifyDiscountCustomerBuysProductVariantToProductVariantKey,
  ShopifyDiscountCustomerGetsCollectionKey,
  ShopifyDiscountCustomerGetsCollectionToCollectionKey,
  ShopifyDiscountCustomerGetsCollectionToDiscountKey,
  ShopifyDiscountCustomerGetsProductKey,
  ShopifyDiscountCustomerGetsProductToDiscountKey,
  ShopifyDiscountCustomerGetsProductToProductKey,
  ShopifyDiscountCustomerGetsProductVariantKey,
  ShopifyDiscountCustomerGetsProductVariantToDiscountKey,
  ShopifyDiscountCustomerGetsProductVariantToProductVariantKey,
  ShopifyDiscountKey,
  ShopifyDiscountRedeemCodeKey,
  ShopifyDiscountRedeemCodeToDiscountKey,
  ShopifyDiscountToCustomerBuysCollectionKey,
  ShopifyDiscountToCustomerBuysProductKey,
  ShopifyDiscountToCustomerBuysProductVariantKey,
  ShopifyDiscountToCustomerGetsCollectionKey,
  ShopifyDiscountToCustomerGetsProductKey,
  ShopifyDiscountToCustomerGetsProductVariantKey,
  ShopifyDiscountToDiscountRedeemCodesKey,
  ShopifyDiscountToShopKey,
  ShopifyProductKey,
  ShopifyProductToCustomerBuysProductKey,
  ShopifyProductToCustomerGetsProductKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantToCustomerBuysProductVariantKey,
  ShopifyProductVariantToCustomerGetsProductVariantKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

// we added shopify field keys in 2025-04 which changes how the static keys are generated. these are here so that they remain the same
const shopifyCreatedAtKey = "ModelField-DataModel-Shopify-Discount-createdAt";
const shopifyCreatedAtStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Discount-createdAt-initial";
const shopifyUpdatedAtKey = "ModelField-DataModel-Shopify-Discount-updatedAt";
const shopifyUpdatedAtStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Discount-updatedAt-initial";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDiscountKey,
  defaultFilterableApiIdentifiers: ["status"],
  "2022-07": {
    name: "Shopify Discount",
    graphQLTypename: "DiscountAutomaticNode",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id", skipGraphQLSelection: true } },
      },
      {
        name: "Discount ID",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountId",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeApp"],
          },
        },
      },
      {
        name: "App Discount Type",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appDiscountType",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeApp"],
            graphQLSelection: `
            app {
              id
            }
            appBridge {
              createPath
              detailsPath
            }
            appKey
            description
            discountClass
            functionId
            targetType
            title
            `,
          },
        },
      },
      {
        name: "Combines With",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "combinesWith",
            graphQLSelection: `
            orderDiscounts
            productDiscounts
            shippingDiscounts
            `,
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Discount Class",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountClass",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ORDER" }, { name: "PRODUCT" }, { name: "SHIPPING" }],
          allowMultiple: false,
          allowOther: true,
        },
      },
      {
        name: "Ends At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "endsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Starts At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "startsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Error History",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "errorHistory",
            graphQLSelection: `
            errorsFirstOccurredAt
            firstOccurredAt
            hasBeenSharedSinceLastError
            hasSharedRecentErrors
            `,
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeApp"],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "status",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ACTIVE" }, { name: "EXPIRED" }, { name: "SCHEDULED" }],
          allowOther: true,
          allowMultiple: false,
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "title",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Async Usage Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "asyncUsageCount",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Short Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shortSummary",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "summary",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Minimum Requirement",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "minimumRequirement",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping"],
            graphQLSelection: `
            ... on DiscountMinimumQuantity {
              greaterThanOrEqualToQuantity
            }
            ... on DiscountMinimumSubtotal {
              greaterThanOrEqualToSubtotal {
                amount
                currencyCode
              }
            }
            `,
          },
        },
      },
      {
        name: "Uses Per Order Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "usesPerOrderLimit",
            graphQLFragments: ["DiscountAutomaticBxgy", "DiscountCodeBxgy"],
          },
        },
      },
      {
        name: "Applies Once Per Customer",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOncePerCustomer",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Has Timeline Comment",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasTimelineComment",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Recurring Cycle Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "recurringCycleLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Shareable URLs",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shareableUrls",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
            graphQLSelection: `
            targetItemImage {
              id
            }
            targetType
            title
            url
            `,
          },
        },
      },
      {
        name: "Total Sales",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalSales",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Usage Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "usageLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Code Count",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codeCount",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "updatedAt",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "createdAt",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
            ],
          },
        },
      },
      {
        name: "Applies On One Time Purchase",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnOneTimePurchase",
            graphQLFragments: ["DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Applies On Subscription",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnSubscription",
            graphQLFragments: ["DiscountCodeFreeShipping"],
          },
        },
      },
      {
        name: "Destination Selection",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "destinationSelection",
            graphQLFragments: ["DiscountCodeFreeShipping"],
            graphQLSelection: `
            ... on DiscountCountries {
              countries
              includeRestOfWorld
            }
            ... on DiscountCountryAll {
              allCountries
            }
            `,
          },
        },
      },
      {
        name: "Maximum Shipping Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "maximumShippingPrice",
            graphQLFragments: ["DiscountCodeFreeShipping"],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "custom", resource: "discountNodes" },
  },
  "2023-07": {
    fields: [
      {
        name: "Customer Gets",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "customerGets",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountAutomaticBxgy", "DiscountCodeBasic", "DiscountCodeBxgy"],
            graphQLSelection: `
            appliesOnOneTimePurchase
            appliesOnSubscription
            items {
              ... on AllDiscountItems {
                allItems
              }
            }
            value {
              ... on DiscountAmount {
                amount {
                  amount
                  currencyCode
                }
                appliesOnEachItem
              }
              ... on DiscountOnQuantity {
                effect {
                  ... on DiscountPercentage {
                    percentage
                  }
                }
                quantity {
                  quantity
                }
              }
              ... on DiscountPercentage {
                percentage
              }
            }
            `,
          },
        },
      },
      {
        name: "Customer Gets Products",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyDiscountToCustomerGetsProductKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerGetsProductKey,
          relatedModelKey: ShopifyProductKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerGetsProductToDiscountKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerGetsProductToProductKey,
          inverseFieldKey: ShopifyProductToCustomerGetsProductKey,
          dependent: "delete",
        },
      },
      {
        name: "Customer Gets Product Variants",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyDiscountToCustomerGetsProductVariantKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerGetsProductVariantKey,
          relatedModelKey: ShopifyProductVariantKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerGetsProductVariantToDiscountKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerGetsProductVariantToProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToCustomerGetsProductVariantKey,
          dependent: "delete",
        },
      },
      {
        name: "Customer Gets Collections",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyDiscountToCustomerGetsCollectionKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerGetsCollectionKey,
          relatedModelKey: ShopifyCollectionKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerGetsCollectionToDiscountKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerGetsCollectionToCollectionKey,
          inverseFieldKey: ShopifyCollectionToCustomerGetsCollectionKey,
          dependent: "delete",
        },
      },
      {
        name: "Customer Buys",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "customerBuys",
            graphQLFragments: ["DiscountAutomaticBxgy", "DiscountCodeBxgy"],
            graphQLSelection: `
            items {
              ... on AllDiscountItems {
                allItems
              }
            }
            value {
              ... on DiscountPurchaseAmount {
                amount
              }
              ... on DiscountQuantity {
                quantity
              }
            }`,
          },
        },
      },
      {
        name: "Customer Buys Products",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyDiscountToCustomerBuysProductKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerBuysProductKey,
          relatedModelKey: ShopifyProductKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerBuysProductToDiscountKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerBuysProductToProductKey,
          inverseFieldKey: ShopifyProductToCustomerBuysProductKey,
          dependent: "delete",
        },
      },
      {
        name: "Customer Buys Product Variants",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyDiscountToCustomerBuysProductVariantKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerBuysProductVariantKey,
          relatedModelKey: ShopifyProductVariantKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerBuysProductVariantToDiscountKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerBuysProductVariantToProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToCustomerBuysProductVariantKey,
          dependent: "delete",
        },
      },
      {
        name: "Customer Buys Collections",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyDiscountToCustomerBuysCollectionKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerBuysCollectionKey,
          relatedModelKey: ShopifyCollectionKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerBuysCollectionToDiscountKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerBuysCollectionToCollectionKey,
          inverseFieldKey: ShopifyCollectionToCustomerBuysCollectionKey,
          dependent: "delete",
        },
      },
      {
        name: "Codes",
        fieldType: FieldType.HasMany,
        key: ShopifyDiscountToDiscountRedeemCodesKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codes",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyDiscountRedeemCodeKey,
          inverseFieldKey: ShopifyDiscountRedeemCodeToDiscountKey,
        },
      },
    ],
  },
  "2024-01": {
    name: "Shopify Discount",
    fields: [
      {
        name: "Combines With",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "combinesWith",
            graphQLSelection: `
            orderDiscounts
            productDiscounts
            shippingDiscounts
            `,
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Discount Class",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountClass",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ORDER" }, { name: "PRODUCT" }, { name: "SHIPPING" }],
          allowMultiple: false,
          allowOther: true,
        },
      },
      {
        name: "Ends At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "endsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Starts At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "startsAt",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "status",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ACTIVE" }, { name: "EXPIRED" }, { name: "SCHEDULED" }],
          allowOther: true,
          allowMultiple: false,
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "title",
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Async Usage Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "asyncUsageCount",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Short Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shortSummary",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Summary",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "summary",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Minimum Requirement",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "minimumRequirement",
            graphQLFragments: ["DiscountAutomaticBasic", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
            graphQLSelection: `
            ... on DiscountMinimumQuantity {
              greaterThanOrEqualToQuantity
            }
            ... on DiscountMinimumSubtotal {
              greaterThanOrEqualToSubtotal {
                amount
                currencyCode
              }
            }
            `,
          },
        },
      },
      {
        name: "Has Timeline Comment",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasTimelineComment",
            graphQLFragments: [
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Recurring Cycle Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "recurringCycleLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Total Sales",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "totalSales",
            graphQLFragments: [
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "updatedAt",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "createdAt",
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Applies On One Time Purchase",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnOneTimePurchase",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Applies On Subscription",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnSubscription",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Destination Selection",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "destinationSelection",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
            graphQLSelection: `
            ... on DiscountCountries {
              countries
              includeRestOfWorld
            }
            ... on DiscountCountryAll {
              allCountries
            }
            `,
          },
        },
      },
      {
        name: "Maximum Shipping Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "maximumShippingPrice",
            graphQLFragments: ["DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Type",
        fieldType: FieldType.Enum,
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [
            { name: "DiscountAutomaticApp" },
            { name: "DiscountAutomaticBasic" },
            { name: "DiscountAutomaticBxgy" },
            { name: "DiscountAutomaticFreeShipping" },
            { name: "DiscountCodeApp" },
            { name: "DiscountCodeBasic" },
            { name: "DiscountCodeBxgy" },
            {
              name: "DiscountCodeFreeShipping",
            },
          ],
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "__typename",
          },
        },
      },
    ],
    syncConfig: { type: "custom", resource: "discountNodes" },
  },
  "2024-04": {
    hasMetafields: true,
    fields: [
      {
        name: "Code Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codeCount",
          },
        },
        isDeleted: true,
      },
      {
        name: "Codes Count",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "codesCount",
            graphQLSelection: `
            count
            precision`,
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeBxgy", "DiscountCodeFreeShipping"],
          },
        },
      },
    ],
  },
  "2024-10": {
    fields: [
      {
        name: "Applies On Subscription",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnSubscription",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping"],
          },
        },
      },
      {
        name: "Recurring Cycle Limit",
        fieldType: FieldType.Number,
        configuration: {
          decimals: 0,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "recurringCycleLimit",
            graphQLFragments: ["DiscountCodeApp", "DiscountCodeBasic", "DiscountCodeFreeShipping", "DiscountAutomaticApp"],
          },
        },
      },
    ],
  },
  "2025-01": {
    fields: [
      {
        name: "Applies On Subscription",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnSubscription",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping", "DiscountCodeApp"],
          },
        },
      },
      {
        name: "Applies On One Time Purchase",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "appliesOnOneTimePurchase",
            graphQLFragments: ["DiscountAutomaticApp", "DiscountCodeFreeShipping", "DiscountAutomaticFreeShipping", "DiscountCodeApp"],
          },
        },
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "status",
            shopifyFieldKey: "status",
            availableInWebhook: ["discounts/create", "discounts/update"],
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
        configuration: {
          options: [{ name: "ACTIVE" }, { name: "EXPIRED" }, { name: "SCHEDULED" }],
          allowOther: true,
          allowMultiple: false,
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "title",
            shopifyFieldKey: "title",
            availableInWebhook: ["discounts/create", "discounts/update"],
            graphQLFragments: [
              "DiscountAutomaticApp",
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Shopify Updated At",
        key: shopifyUpdatedAtKey,
        initialStorageEpochKey: shopifyUpdatedAtStorageEpochKey,
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "updatedAt",
            shopifyFieldKey: "updated_at",
            availableInWebhook: ["discounts/create", "discounts/update"],
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
      {
        name: "Shopify Created At",
        key: shopifyCreatedAtKey,
        initialStorageEpochKey: shopifyCreatedAtStorageEpochKey,
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "createdAt",
            shopifyFieldKey: "created_at",
            availableInWebhook: ["discounts/create", "discounts/update"],
            graphQLFragments: [
              "DiscountAutomaticBasic",
              "DiscountAutomaticBxgy",
              "DiscountCodeApp",
              "DiscountCodeBasic",
              "DiscountCodeBxgy",
              "DiscountCodeFreeShipping",
              "DiscountAutomaticFreeShipping",
            ],
          },
        },
      },
    ],
  },
};

export const ShopifyDiscount = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
